import { jsxs, jsx } from 'react/jsx-runtime';
import { useDatePickerContext } from '../context/datePickerContext.mjs';
import { getDayCountInRange } from '../utils/getDayCountInRange.mjs';
import { useLinearLocale } from '../../locale/LocaleContext.mjs';
import { localeValue } from '../constants/localeValues.mjs';
import { localeValues } from './localeValues.mjs';
import ControllerContainer from './base/ControllerContainer.mjs';
import DatePickerClear from './Clear.mjs';

const CONTROLLER_NAME = "Controller";
const DatePickerController = ({
  children,
  __scopeDatePicker,
  ...props
}) => {
  const { mode, startDate, endDate, selectedDate, excludeDates } = useDatePickerContext(CONTROLLER_NAME, __scopeDatePicker);
  const { locale } = useLinearLocale();
  const isRangeMode = mode === "range";
  const singleModeCount = !isRangeMode && selectedDate !== null ? 1 : 0;
  const rangeModeCount = isRangeMode && startDate !== null && endDate !== null ? getDayCountInRange(startDate, endDate, excludeDates) : 0;
  const selectedDateCount = Math.max(
    isRangeMode ? rangeModeCount : singleModeCount,
    0
  );
  const rangeLabel = isRangeMode && selectedDateCount > 0 ? localeValue[locale].itemCount(selectedDateCount) : "";
  if (typeof children === "function") {
    return children({
      selectedDateCount,
      isRangeMode
    });
  }
  const notAllowedToClear = isRangeMode ? startDate === null && endDate === null : selectedDate === null;
  return /* @__PURE__ */ jsxs(ControllerContainer, { ...props, children: [
    /* @__PURE__ */ jsx(ControllerContainer.InfoText, { children: isRangeMode && rangeLabel ? rangeLabel : localeValue[locale].optionalInputDescription }),
    /* @__PURE__ */ jsx(DatePickerClear, { asChild: true, children: /* @__PURE__ */ jsx(ControllerContainer.ClearButton, { disabled: notAllowedToClear, children: localeValues[locale].clear }) })
  ] });
};
DatePickerController.ClearButton = ControllerContainer.ClearButton;

export { DatePickerController as default };
//# sourceMappingURL=Controller.mjs.map
